import { createSlice } from '@reduxjs/toolkit'

// general imports
import { addAutomaticTransactionTypesV2 } from '../../../services/api'
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { addAutomaticTransactionThunk } from '../thunks/transactions.thunk'

export type addAutomaticTransactionState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType
  automaticTransaction: addAutomaticTransactionTypesV2
}

export const initialState: addAutomaticTransactionState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
  automaticTransaction: {} as addAutomaticTransactionTypesV2,
}

const addAutomaticTransactionSlice = createSlice({
  name: 'addAutomaticTransactionSlice',
  initialState: initialState,
  reducers: {
    resetaddAutomaticTransactionState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAutomaticTransactionThunk.pending, (state) => {
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(addAutomaticTransactionThunk.fulfilled, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        state.automaticTransaction = action.payload
        // state.requestResponse.data = action.payload.description
      })
      .addCase(addAutomaticTransactionThunk.rejected, (state, action) => {
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetaddAutomaticTransactionState } = addAutomaticTransactionSlice.actions
export default addAutomaticTransactionSlice.reducer
